import React, { Component } from 'react'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import {
  normalizeStartDate,
  normalizeEndDate,
} from '../../helpers/filterHelper'

import { InputField, CheckboxGroup, StateSelect } from '../../components/inputs'
import { AccessibleOrganizationsSelect } from '../../components/inputs/accessibleOrganizationsSelect'
import LoaderButton from '../../components/loaderButton'
import { ReduxFormProps } from '../../forms'

// auto-correct date inputs to mm/dd/yyyy
const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy')

export type Callback<T = void> = (...args: any) => T

export interface Props {
  clearFields?: Callback
  clear: Callback
  cancel: Callback
  activeGroup?: 'quote' | 'sold' | 'cancel' | 'status' | null
}

export interface FormProps {
  name: string
  productPackage: string
  currentAdmin: string
  address?: string
  city?: string
  state?: string
  zip?: string
  quotedAtAfter?: string
  quotedAtBefore?: string
  remittedAtAfter?: string
  remittedAtBefore?: string
  cancelledAtAfter?: string
  cancelledAtBefore?: string
  updatedAtAfter?: string
  updatedAtBefore?: string
  customerCodeContains?: string
}

export class ProductFilterForm extends Component<
  ReduxFormProps<Props, FormProps>
> {
  static displayName = 'ProductFilterForm'

  render() {
    const { handleSubmit, submitting, clear, cancel, activeGroup } = this.props

    const statusOptions = [
      { label: 'Remitted', value: 'remitted' },
      { label: 'Active', value: 'active' },
      { label: 'Pending Late', value: 'pending_late' },
      { label: 'Late', value: 'late' },
      { label: 'Pending Cancel', value: 'pending_cancel' },
      { label: 'Expired', value: 'expired' },
      { label: 'Unwind', value: 'unwind' },
      { label: 'Cancelled', value: 'cancelled' },
      { label: 'Back Out', value: 'back_out' },
      {label: 'Product Remitted Error', value: 'product_remitted_error'},
      {label: 'Payment Remitted Error', value: 'payment_remitted_error'},
      {label: 'Product And Payment Remitted Error', value: 'product_and_payment_remitted_error'},
      { label: 'Agreement Signed', value: 'agreement_signed' },
      {label: 'Product Agreement Signed', value: 'product_agreement_signed'},
      {label: 'Payment Agreement Signed', value: 'payment_agreement_signed'},
      { label: 'Payment Succeeded', value: 'payment_succeeded' },
      { label: 'Payment Failed', value: 'payment_failed' },
      { label: 'Booked', value: 'booked' },
      { label: 'Selected', value: 'selected' },
      { label: 'Quoted', value: 'quoted' },
      { label: 'Empty', value: 'empty' },
    ]

    const disableGroup = (group: 'quote' | 'sold' | 'cancel' | 'status') =>
      !!(activeGroup && activeGroup !== group)

    return (
      <form
        className="form index-filter__form"
        name="ProductFilterForm"
        onSubmit={handleSubmit}
      >
        <div className="filter">
          <div>
            <h2 className="filter__header">Customer Name</h2>
            <hr className="form__hr  filter__hr" />
            <Field
              type="text"
              label="Enter a Customer name"
              name="name"
              component={InputField}
              gridClass="filter__field"
            />
          </div>

          <div>
            <h2 className="filter__header">Customer Code</h2>
            <hr className="form__hr  filter__hr" />
            <Field
              type="text"
              label="Enter a Customer code"
              name="customerCodeContains"
              component={InputField}
              gridClass="filter__field"
            />
          </div>

          <div>
            <h2 className="filter__header">Customer Email</h2>
            <hr className="form__hr  filter__hr" />
            <Field
              type="text"
              label="Enter a Customer email address"
              name="email"
              component={InputField}
              gridClass="filter__field"
            />
          </div>

          <div>
            <h2 className="filter__header">Customer Phone</h2>
            <hr className="form__hr  filter__hr" />
            <Field
              type="text"
              label="Enter a Customer phone number"
              name="phone"
              component={InputField}
              gridClass="filter__field"
            />
          </div>

          <div>
            <h2 className="filter__header">Agent Name</h2>
            <hr className="form__hr  filter__hr" />
            <Field
              type="text"
              label="Enter an Agent name"
              name="currentAdmin"
              component={InputField}
              gridClass="filter__field"
            />
          </div>

          <div>
            <h2 className="filter__header">Address</h2>
            <hr className="form__hr filter__hr" />
            <Field
              type="text"
              label="Enter an address"
              name="address"
              component={InputField}
              gridClass="filter__field"
            />
          </div>

          <div>
            <h2 className="filter__header">City</h2>
            <hr className="form__hr filter__hr" />
            <Field
              type="text"
              label="Enter a city"
              name="city"
              component={InputField}
              gridClass="filter__field"
            />
          </div>

          <div>
            <h2 className="filter__header">State</h2>
            <hr className="form__hr filter__hr" />
            <StateSelect
              defaultOption="No state selected"
              label="Select a state"
              name="state"
            />
          </div>

          <div>
            <h2 className="filter__header">Organizations</h2>
            <hr className="form__hr filter__hr" />
            <AccessibleOrganizationsSelect
              label="Select organizations"
              name="organizations"
            />
          </div>

          <div>
            <h2 className="filter__header">Zip</h2>
            <hr className="form__hr filter__hr" />
            <Field
              type="text"
              label="Enter a zip code"
              name="zip"
              component={InputField}
              gridClass="filter__field"
            />
          </div>
          <div>
            <h2 className="filter__header">VIN</h2>
            <hr className="form__hr filter__hr" />
            <Field
              type="text"
              label="Enter a Vehicle VIN"
              name="vin"
              component={InputField}
              gridClass="filter__field"
            />
          </div>

          <div>
            <h2 className="filter__header">Quote Date</h2>
            <hr className="form__hr filter__hr" />
            <div className="filter__date-fields">
              <Field
                type="text"
                label="From"
                name="quotedAtAfter"
                component={InputField}
                placeholder="mm/dd/yyyy"
                disabled={disableGroup('quote')}
                mask={[
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                pipe={autoCorrectedDatePipe}
                normalize={normalizeStartDate}
                keepCharPositions={true}
                gridClass="filter__field"
              />
              <Field
                type="text"
                label="To"
                name="quotedAtBefore"
                component={InputField}
                placeholder="mm/dd/yyyy"
                disabled={disableGroup('quote')}
                mask={[
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                pipe={autoCorrectedDatePipe}
                normalize={normalizeEndDate}
                keepCharPositions={true}
                gridClass="filter__field"
              />
            </div>
          </div>

          <div>
            <h2 className="filter__header">Sold/Remitted Date</h2>
            <hr className="form__hr filter__hr" />
            <div className="filter__date-fields">
              <Field
                type="text"
                label="From"
                name="remittedAtAfter"
                component={InputField}
                placeholder="mm/dd/yyyy"
                disabled={disableGroup('sold')}
                mask={[
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                pipe={autoCorrectedDatePipe}
                normalize={normalizeStartDate}
                keepCharPositions={true}
                gridClass="filter__field"
              />
              <Field
                type="text"
                label="To"
                name="remittedAtBefore"
                component={InputField}
                placeholder="mm/dd/yyyy"
                disabled={disableGroup('sold')}
                mask={[
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                pipe={autoCorrectedDatePipe}
                normalize={normalizeEndDate}
                keepCharPositions={true}
                gridClass="filter__field"
              />
            </div>
          </div>

          <div>
            <h2 className="filter__header">Cancel Date</h2>
            <hr className="form__hr filter__hr" />
            <div className="filter__date-fields">
              <Field
                type="text"
                label="From"
                name="cancelledAtAfter"
                component={InputField}
                placeholder="mm/dd/yyyy"
                disabled={disableGroup('cancel')}
                mask={[
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                pipe={autoCorrectedDatePipe}
                normalize={normalizeStartDate}
                keepCharPositions={true}
                gridClass="filter__field"
              />
              <Field
                type="text"
                label="To"
                name="cancelledAtBefore"
                component={InputField}
                placeholder="mm/dd/yyyy"
                disabled={disableGroup('cancel')}
                mask={[
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                pipe={autoCorrectedDatePipe}
                normalize={normalizeEndDate}
                keepCharPositions={true}
                gridClass="filter__field"
              />
            </div>
          </div>

          <div>
            <h2 className="filter__header">Status Date</h2>
            <hr className="form__hr filter__hr" />
            <div className="filter__date-fields">
              <Field
                type="text"
                label="From"
                name="updatedAtAfter"
                component={InputField}
                placeholder="mm/dd/yyyy"
                disabled={disableGroup('status')}
                mask={[
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                pipe={autoCorrectedDatePipe}
                normalize={normalizeStartDate}
                keepCharPositions={true}
                gridClass="filter__field"
              />
              <Field
                type="text"
                label="To"
                name="updatedAtBefore"
                component={InputField}
                placeholder="mm/dd/yyyy"
                disabled={disableGroup('status')}
                mask={[
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                pipe={autoCorrectedDatePipe}
                normalize={normalizeEndDate}
                keepCharPositions={true}
                gridClass="filter__field"
              />
            </div>
          </div>

          <div>
            <h2 className="filter__header">Status</h2>
            <hr className="form__hr filter__hr" />

            <CheckboxGroup
              name="productPackage"
              gridRow
              options={statusOptions}
              aria-required="true"
              gridClass="filter__status-field filter__field"
            />
          </div>

          <hr className="form__hr  filter__button-hr" />
          <div className="form__group filter__buttons">
            <LoaderButton
              type="submit"
              className="button button--primary filter__button--apply"
              isLoading={submitting}
            >
              Apply
            </LoaderButton>
            <a
              onClick={clear}
              className="button button--secondary filter__button--reset"
              aria-label="Reset"
              data-testid="product-filter-reset"
            >
              Reset
            </a>
          </div>
          <a
            onClick={cancel}
            className="button button-link-text filter__cancel"
            data-testid="product-filter-cancel"
          >
            Cancel
          </a>
        </div>
      </form>
    )
  }
}

export const validate = (data) => {
  const { name, currentAdmin } = data
  const errors: Partial<FormProps> = {}

  if (!/^[a-zA-Z\s]*$/.test(name)) {
    errors.name = 'Only letters are allowed'
  }

  if (!/^[a-zA-Z\s]*$/.test(currentAdmin)) {
    errors.currentAdmin = 'Only letters are allowed'
  }

  return errors
}

const selector = formValueSelector('productFilterForm')

const mapStateToProps = (
  state
): { activeGroup: 'quote' | 'sold' | 'cancel' | 'status' | null } => {
  const quotedAtAfter = selector(state, 'quotedAtAfter')
  const quotedAtBefore = selector(state, 'quotedAtBefore')
  const remittedAtAfter = selector(state, 'remittedAtAfter')
  const remittedAtBefore = selector(state, 'remittedAtBefore')
  const cancelledAtAfter = selector(state, 'cancelledAtAfter')
  const cancelledAtBefore = selector(state, 'cancelledAtBefore')
  const updatedAtAfter = selector(state, 'updatedAtAfter')
  const updatedAtBefore = selector(state, 'updatedAtBefore')

  const activeGroup: 'quote' | 'sold' | 'cancel' | 'status' | null = (() => {
    if (quotedAtAfter || quotedAtBefore) return 'quote'
    if (remittedAtAfter || remittedAtBefore) return 'sold'
    if (cancelledAtAfter || cancelledAtBefore) return 'cancel'
    if (updatedAtAfter || updatedAtBefore) return 'status'

    return null
  })()

  return { activeGroup }
}

export default connect(mapStateToProps)(
  reduxForm<FormProps, Props>({
    form: 'productFilterForm',
    validate,
    enableReinitialize: false,
    destroyOnUnmount: true,
  })(ProductFilterForm)
)
